<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      The path or value for the OrganizationId whose owned wells you want to process:
      <input type="text" [(ngModel)]="seConfiguration.organizationId" />
    </label>
  </div>
</div>

<div class="grid-x grid-margin-x">
  <div class="cell small-12">
    <label>
      (This will only be filled in if the bonding org was not in compliance prior to submitting this flow, had any wells with FA still being maintained by
      another org,  but is now in compliance.)
      The context path to store the OrganizationId previously maintaining FA on any of the owned wells:
      <input type="text" [(ngModel)]="seConfiguration.faOrganizationIdContextTarget" />
    </label>
  </div>
</div>

<div class="cell small-4 checkbox small-font-size">
  <label for="showWellTransferFields">
    Is this side effect being configured as part of the well transfer process?
  </label>
</div>
<div class=" cell small-6">
  <input type="checkbox" id="showWellTransferFields" [(ngModel)]="isPartofWellTransfer" />
</div>

@if (isPartofWellTransfer) {
  <div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          The path or value for the OrganizationId you're transferring the well from:
          <input type="text" [(ngModel)]="seConfiguration.sellerOrganizationId" />
        </label>
      </div>
    </div>
    <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <label>
          The path or value for the list of wells or their APIs you're transferring:
          <input type="text" [(ngModel)]="seConfiguration.wellsToTransfer" />
        </label>
      </div>
    </div>
    <div class="cell small-4 checkbox small-font-size">
      <label for="targetObjectIsArrayOfWells">
        Is the object an array of wells as opposed to an array of API #?
      </label>
    </div>
    <div class=" cell small-6">
      <input type="checkbox" id="targetObjectIsArrayOfWells" [(ngModel)]="seConfiguration.targetObjectIsArrayOfWells" />
    </div>
  </div>
}